import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import { COMPANY, LOGO, NAV_LINKS, LEGAL_LINKS } from "@/lib/site";

export const Footer = () => (
    <footer data-testid="site-footer" className="bg-slate-950 text-slate-400">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
            <div className="grid gap-12 lg:grid-cols-[1.5fr_1fr_1fr_1fr]">
                <div>
                    <div className="inline-block rounded-2xl bg-white p-3">
                        <img src={LOGO} alt="Virtex Renewables logo" className="h-10 w-auto" />
                    </div>
                    <p className="mt-5 font-display text-sm font-semibold uppercase tracking-[0.2em] text-emerald-500">
                        {COMPANY.tagline}
                    </p>
                    <p className="mt-3 max-w-sm text-sm leading-relaxed">
                        Air Source Heat Pump Specialists serving homeowners and landlords across England &amp; Wales.
                    </p>
                    <div className="mt-6 space-y-2.5">
                        <a href={COMPANY.phoneHref} data-testid="footer-phone-link" className="flex items-center gap-2.5 text-sm font-semibold text-white transition-colors hover:text-emerald-400">
                            <Phone className="h-4 w-4 text-emerald-500" /> {COMPANY.phoneDisplay}
                        </a>
                        <a href={COMPANY.emailHref} data-testid="footer-email-link" className="flex items-center gap-2.5 text-sm font-semibold text-white transition-colors hover:text-emerald-400">
                            <Mail className="h-4 w-4 text-emerald-500" /> {COMPANY.email}
                        </a>
                    </div>
                </div>

                <nav aria-label="Footer navigation">
                    <p className="font-display text-sm font-bold uppercase tracking-wider text-white">Explore</p>
                    <ul className="mt-4 space-y-2.5">
                        {NAV_LINKS.map((link) => (
                            <li key={link.to}>
                                <Link to={link.to} data-testid={`footer-${link.label.toLowerCase().replace(/[^a-z]+/g, "-")}-link`} className="text-sm transition-colors hover:text-emerald-400">
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>

                <nav aria-label="Legal">
                    <p className="font-display text-sm font-bold uppercase tracking-wider text-white">Legal</p>
                    <ul className="mt-4 space-y-2.5">
                        {LEGAL_LINKS.map((link) => (
                            <li key={link.to}>
                                <Link to={link.to} data-testid={`footer-${link.label.toLowerCase().replace(/[^a-z]+/g, "-")}-link`} className="text-sm transition-colors hover:text-emerald-400">
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>

                <div>
                    <p className="font-display text-sm font-bold uppercase tracking-wider text-white">Registered Office</p>
                    <address className="mt-4 text-sm not-italic leading-relaxed">
                        {COMPANY.registeredOffice.map((line) => (
                            <span key={line} className="block">{line}</span>
                        ))}
                    </address>
                </div>
            </div>

            <div className="mt-14 border-t border-slate-800 pt-8">
                <p className="text-sm text-slate-500">© 2026 Virtex Renewables Ltd. All rights reserved.</p>
                <p className="mt-2 max-w-4xl text-xs leading-relaxed text-slate-600">
                    Virtex Renewables Ltd is registered in England and Wales. Company No. 17467990. Registered Office:
                    Flat 2 Park Lane Court, 31 Parsonage Road, Manchester, England, M20 4PS.
                </p>
            </div>
        </div>
    </footer>
);
